import React from 'react';
import { Chip } from '@material-ui/core';

interface DeactivatedLabelProps {
  style?: React.CSSProperties;
}

const DeactivatedLabel: React.FC<DeactivatedLabelProps> = ({ style }) => {
  return (
    <Chip 
      label="DEACTIVATED" 
      size="small" 
      color="primary"
      style={{
        backgroundColor: '#757575',
        color: 'white',
        ...style
      }}
    />
  );
};

export default DeactivatedLabel;
